(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["app-univers"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('app-universe-motion')) {
    customElements.define('app-universe-motion', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = this.dataset.autoplay === 'false';
        this.interval = Number(this.dataset.interval || 5) * 1000;
        this.toggle = this.querySelector('[data-universe-pause]');
        this.cards = Array.from(this.querySelectorAll('[data-universe-card]'), (element, order) => ({
          element, order, slides: Array.from(element.querySelectorAll('[data-universe-slide]')),
          indicators: Array.from(element.querySelectorAll('.app-univers__indicators span')),
          index: 0, visible: false, hovered: false, focused: false, busy: false, timer: null, cleanup: null
        }));
        const options = { signal: this.controller.signal };
        this.toggle?.addEventListener('click', () => { this.paused = !this.paused; this.sync(); }, options);
        this.cards.forEach((card) => {
          const controls = card.element.querySelector('[data-universe-controls]');
          if (controls) controls.hidden = false;
          card.element.querySelector('[data-universe-next]')?.addEventListener('click', () => this.advance(card, 1, true), options);
          card.element.querySelector('[data-universe-previous]')?.addEventListener('click', () => this.advance(card, -1, true), options);
          card.element.addEventListener('pointerenter', (event) => { if (event.pointerType !== 'touch') { card.hovered = true; this.schedule(card); } }, options);
          card.element.addEventListener('pointerleave', () => { card.hovered = false; this.schedule(card); }, options);
          card.element.addEventListener('focusin', () => { card.focused = true; this.schedule(card); }, options);
          card.element.addEventListener('focusout', (event) => { if (!card.element.contains(event.relatedTarget)) { card.focused = false; this.schedule(card); } }, options);
          let touchStart;
          const visual = card.element.querySelector('[data-universe-visual]');
          visual.addEventListener('touchstart', (event) => { touchStart = event.touches[0]; }, { ...options, passive: true });
          visual.addEventListener('touchend', (event) => {
            if (!touchStart) return;
            const end = event.changedTouches[0];
            const distance = end.clientX - touchStart.clientX;
            if (Math.abs(distance) > 35 && Math.abs(distance) > Math.abs(end.clientY - touchStart.clientY)) {
              card.ignoreClick = true;
              clearTimeout(card.clickTimer);
              card.clickTimer = setTimeout(() => { card.ignoreClick = false; }, 350);
              this.advance(card, distance < 0 ? 1 : -1, true);
            }
            touchStart = null;
          }, { ...options, passive: true });
          card.element.querySelector('a').addEventListener('click', (event) => {
            if (card.ignoreClick) { event.preventDefault(); card.ignoreClick = false; }
          }, options);
        });
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              const card = this.cards.find((item) => item.element === entry.target);
              card.visible = entry.isIntersecting;
              card.element.dataset.inView = String(card.visible);
              if (card.visible && card.slides.length) this.preload(card, (card.index + 1) % card.slides.length);
              this.schedule(card, true);
            });
          }, { threshold: .2 });
          this.cards.forEach((card) => this.observer.observe(card.element));
        } else {
          this.cards.forEach((card) => { card.visible = true; card.element.dataset.inView = 'true'; });
        }
        document.addEventListener('visibilitychange', () => this.sync(), options);
        this.reduced.addEventListener('change', () => this.sync(), options);
        this.dataset.enhanced = 'true';
        this.sync();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.cards?.forEach((card) => { clearTimeout(card.timer); clearTimeout(card.cleanup); clearTimeout(card.clickTimer); });
        this.controller = null;
      }
      sync() {
        this.dataset.paused = String(this.paused || this.reduced.matches || document.hidden);
        if (this.toggle) {
          this.toggle.hidden = this.reduced.matches || !this.cards.some((card) => card.slides.length > 1);
          this.toggle.setAttribute('aria-pressed', String(this.paused));
          this.toggle.querySelector('span').textContent = this.paused ? this.dataset.resumeLabel : this.dataset.pauseLabel;
          this.toggle.querySelector('[data-pause-symbol]').setAttribute('d', this.paused ? 'M8 5l11 7-11 7V5Z' : 'M9 5v14M15 5v14');
        }
        this.cards.forEach((card) => this.schedule(card));
      }
      schedule(card, stagger = false) {
        clearTimeout(card.timer);
        if (!this.isConnected || this.paused || this.reduced.matches || document.hidden || !card.visible || card.hovered || card.focused || card.slides.length < 2) return;
        card.timer = setTimeout(async () => {
          await this.advance(card, 1);
          this.schedule(card);
        }, this.interval + (stagger ? card.order * 380 : 0));
      }
      preload(card, index) {
        const image = card.slides[index]?.querySelector('img');
        if (image) image.loading = 'eager';
        return image;
      }
      async advance(card, direction, manual = false) {
        if (card.busy || card.slides.length < 2) return;
        card.busy = true;
        const index = (card.index + direction + card.slides.length) % card.slides.length;
        const image = this.preload(card, index);
        try { await image?.decode(); } catch { if (!image?.naturalWidth) { card.busy = false; return; } }
        if (!this.isConnected) { card.busy = false; return; }
        const current = card.slides[card.index];
        const next = card.slides[index];
        const finish = () => {
          card.slides.forEach((slide, position) => {
            slide.hidden = position !== index;
            slide.classList.toggle('is-current', position === index);
            slide.classList.remove('is-leaving');
            slide.setAttribute('aria-hidden', String(position !== index));
          });
          card.busy = false;
        };
        const indicators = () => {
          card.index = index;
          card.element.dataset.activeModel = String(index);
          card.indicators.forEach((indicator, position) => indicator.classList.toggle('is-current', position === index));
        };
        if (manual && document.startViewTransition && !this.reduced.matches && !this.transitioning) {
          this.transitioning = true;
          const visual = card.element.querySelector('[data-universe-visual]');
          visual.style.viewTransitionName = 'universe-model-' + card.order;
          document.documentElement.classList.add('app-universe-transition');
          const transition = document.startViewTransition(() => { indicators(); finish(); });
          try { await transition.finished; } catch {}
          visual.style.viewTransitionName = '';
          document.documentElement.classList.remove('app-universe-transition');
          this.transitioning = false;
        } else if (this.reduced.matches) {
          indicators(); finish();
        } else {
          next.hidden = false;
          next.classList.remove('is-leaving');
          await new Promise((resolve) => requestAnimationFrame(() => requestAnimationFrame(resolve)));
          current.classList.remove('is-current');
          current.classList.add('is-leaving');
          current.setAttribute('aria-hidden', 'true');
          next.classList.add('is-current');
          next.setAttribute('aria-hidden', 'false');
          indicators();
          card.cleanup = setTimeout(finish, 1050);
        }
        this.preload(card, (index + 1) % card.slides.length);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function() {
        const faqItems = document.querySelectorAll('.faq-item');
        faqItems.forEach(item => {
            const question = item.querySelector('.faq-question');
            const answer = item.querySelector('.faq-answer');
            question.addEventListener('click', function() {
                faqItems.forEach(i => {
                    if (i !== item) {
                    i.classList.remove('active');
                    }
                });
                item.classList.toggle('active');
            });
        });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', ()=>{
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    const testimonialEl = document.querySelector('.Testimonial__reviews_interior.swiper');
    if (testimonialEl) {
      const testimonialConfig = { spaceBetween: 12, slidesPerView: 'auto', grabCursor: true };
      if (!isIOS) {
        testimonialConfig.mousewheel = { forceToAxis: true, thresholdDelta: 35 };
        testimonialConfig.freeMode = true;
      }
      new Swiper(testimonialEl, testimonialConfig);
    }

    if( document.querySelectorAll('.pdp__productFaq_widget__question').length > 0 ){
      document.querySelectorAll('.pdp__productFaq_widget__question').forEach((el)=>{
          el.addEventListener('click', (target)=>{
              target.preventDefault();
              target.target.closest('.pdp__productFaq_widget__item').classList.toggle('active');
          })
      })
    }
    if( document.querySelectorAll('.video__playIcon').length > 0 ){
      document.querySelectorAll('.video__playIcon .action--pause').forEach((elm)=>{
        elm.addEventListener('click', (target)=>{
          target.preventDefault();
          target.currentTarget.classList.add('hidden');
          target.target.closest('.Testimonial__video_tagged').querySelector('.action--play').classList.remove('hidden');
          target.target.closest('.Testimonial__video_tagged').querySelector('video').pause();
        })
      });
      document.querySelectorAll('.video__playIcon .action--play').forEach((elm)=>{
        elm.addEventListener('click', (target)=>{
          target.preventDefault();
          target.currentTarget.classList.add('hidden');
          target.target.closest('.Testimonial__video_tagged').querySelector('.action--pause').classList.remove('hidden');
          target.target.closest('.Testimonial__video_tagged').querySelector('video').play();
        })
      });
    }
  });

  document.addEventListener("shopify:section:load", () => {
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    const testimonialEl = document.querySelector('.Testimonial__reviews_interior.swiper');
    if (testimonialEl) {
      const testimonialConfig = { spaceBetween: 12, slidesPerView: 'auto', grabCursor: true };
      if (!isIOS) {
        testimonialConfig.mousewheel = { forceToAxis: true, thresholdDelta: 35 };
        testimonialConfig.freeMode = true;
      }
      new Swiper(testimonialEl, testimonialConfig);
    }

    if( document.querySelectorAll('.pdp__productFaq_widget__question').length > 0 ){
      document.querySelectorAll('.pdp__productFaq_widget__question').forEach((el)=>{
          el.addEventListener('click', (target)=>{
              target.preventDefault();
              target.target.closest('.pdp__productFaq_widget__item').classList.toggle('active');
          })
      })
    }
    if( document.querySelectorAll('.video__playIcon').length > 0 ){
      document.querySelectorAll('.video__playIcon .action--pause').forEach((elm)=>{
        elm.addEventListener('click', (target)=>{
          target.preventDefault();
          target.currentTarget.classList.add('hidden');
          target.target.closest('.Testimonial__video_tagged').querySelector('.action--play').classList.remove('hidden');
          target.target.closest('.Testimonial__video_tagged').querySelector('video').pause();
        })
      });
      document.querySelectorAll('.video__playIcon .action--play').forEach((elm)=>{
        elm.addEventListener('click', (target)=>{
          target.preventDefault();
          target.currentTarget.classList.add('hidden');
          target.target.closest('.Testimonial__video_tagged').querySelector('.action--pause').classList.remove('hidden');
          target.target.closest('.Testimonial__video_tagged').querySelector('video').play();
        })
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-main-product"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', ()=>{
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    const testimonialEl = document.querySelector('.Testimonial__reviews_interior.swiper');
    if (testimonialEl) {
      const testimonialConfig = { spaceBetween: 12, slidesPerView: 'auto', grabCursor: true };
      if (!isIOS) {
        testimonialConfig.mousewheel = { forceToAxis: true, thresholdDelta: 35 };
        testimonialConfig.freeMode = true;
      }
      new Swiper(testimonialEl, testimonialConfig);
    }

    if( document.querySelectorAll('.pdp__productFaq_widget__question').length > 0 ){
      document.querySelectorAll('.pdp__productFaq_widget__question').forEach((el)=>{
          el.addEventListener('click', (target)=>{
              target.preventDefault();
              target.target.closest('.pdp__productFaq_widget__item').classList.toggle('active');
          })
      })
    }
    if( document.querySelectorAll('.video__playIcon').length > 0 ){
      document.querySelectorAll('.video__playIcon .action--pause').forEach((elm)=>{
        elm.addEventListener('click', (target)=>{
          target.preventDefault();
          target.currentTarget.classList.add('hidden');
          target.target.closest('.Testimonial__video_tagged').querySelector('.action--play').classList.remove('hidden');
          target.target.closest('.Testimonial__video_tagged').querySelector('video').pause();
        })
      });
      document.querySelectorAll('.video__playIcon .action--play').forEach((elm)=>{
        elm.addEventListener('click', (target)=>{
          target.preventDefault();
          target.currentTarget.classList.add('hidden');
          target.target.closest('.Testimonial__video_tagged').querySelector('.action--pause').classList.remove('hidden');
          target.target.closest('.Testimonial__video_tagged').querySelector('video').play();
        })
      });
    }

    function isInViewport(elem) {
      const rect = elem.getBoundingClientRect();
      return (
        rect.bottom >= 0 &&
        rect.right >= 0 &&
        rect.top <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.left <= (window.innerWidth || document.documentElement.clientWidth)
      );
    }

    const stickyBar = document.querySelector('.PDP__stk__mainwrapper');
    const header = document.querySelector('.section-header');
    const headerHeight = header ? header.clientHeight : 0;
    const addToCartElements = document.querySelectorAll('[js-scroll-identity]');
    const footerSections = document.querySelectorAll('.shopify-section-group-footer-group');

    function shouldHideSticky() {
      for (const el of [...addToCartElements, ...footerSections]) {
        if (el && isInViewport(el)) return true;
      }
      return false;
    }

    function handleStickyScroll() {
      const scrollY = window.scrollY;
      const triggerElement = document.querySelector('[js-scroll-identity]');
      if (!triggerElement || !stickyBar) return;
      const triggerOffset = triggerElement.offsetTop;
      if (scrollY > triggerOffset) {
        if (shouldHideSticky()) {
          stickyBar.classList.remove('active');
        } else {
          stickyBar.classList.add('active');
        }
      } else {
        stickyBar.classList.remove('active');
      }
    }
    window.addEventListener('scroll', handleStickyScroll, { passive: true });

    document.querySelector('.PDP__stk__actionbtn')?.querySelector('.product-form__submit')?.addEventListener('click',(tg)=>{
      tg.preventDefault();
      document.querySelector('.product-form__buttons')?.querySelector('.product-form__submit')?.click();
    })

  })

  } catch(e) { console.error(e); }
})();
})();
